if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoplay = true; // Set to false to disable autoplay
      this.autoplayInterval = 4000; // Autoplay interval in milliseconds (adjust as needed)
      this.autoplayTimer = null;

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      // Start autoplay timer
      this.startAutoplay();
    }

    startAutoplay() {
      if (this.autoplay) {
        this.autoplayTimer = setInterval(() => {
          this.changeSlide('next');
        }, this.autoplayInterval);
      }
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
    }

    connectedCallback() {
      // Ensure autoplay stops when the element is removed from the DOM
      this.addEventListener('DOMNodeRemovedFromDocument', this.stopAutoplay.bind(this));
    }

    changeSlide(direction) {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if (direction == 'next') {
        this.index = (this.index + 1) % this.length;
      } else if (direction == 'prev') {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

      // Reset autoplay timer after manual slide change
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (typeof customElements.get('announcement-bar') == 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}
